import styled from 'styled-components'

const StyledMenu = styled.div``

export default StyledMenu
